export const getBusinessInfoStepStyles = (_, { palette }) => ({
  // SearchBox inside portaled dropdown callout — portaled to <body>,
  // outside FluentProvider, so CSS variables are unavailable.
  // Uses hardcoded Fluent V2 light theme values.
  '@global': {
    '.ms-Dropdown-callout .ms-SearchBox': {
      borderRadius: '4px',
      borderWidth: 1,
      borderStyle: 'solid',
      borderTopColor: '#d1d1d1 !important',
      borderRightColor: '#d1d1d1 !important',
      borderLeftColor: '#d1d1d1 !important',
      borderBottomColor: '#616161 !important',
    },
    '.ms-Dropdown-callout .ms-SearchBox::after': {
      borderWidth: '0 !important',
    },
    '.ms-Dropdown-callout .ms-SearchBox:focus-within': {
      borderTopColor: '#d1d1d1 !important',
      borderRightColor: '#d1d1d1 !important',
      borderLeftColor: '#d1d1d1 !important',
      borderBottomColor: '#0f6cbd !important',
      borderBottomWidth: '2px !important',
    },
  },
  cardLayout: {
    height: '100%',
    width: '100%',
    backgroundImage: 'radial-gradient(at 2.7% 92.9%, hsl(200, 35%, 93%) 0px, transparent 50%),radial-gradient(at 100.2% 77.6%, hsl(200, 35%, 93%) 0px, transparent 50%),radial-gradient(at 1.3% 13.0%, #f0f3f5 0px, transparent 50%),radial-gradient(at 55.5% 13.8%, #fcf9f5 0px, transparent 50%),radial-gradient(at 55.7% 72.1%, #ffffff 0px, transparent 50%),radial-gradient(at 96.0% 12.2%, hsl(200, 35%, 93%) 0px, transparent 50%)',
    '& .react-block-ui-none, .react-block-ui': {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    '& .react-block-ui.react-block-ui .ui-blocker-overlay': {
      position: 'absolute',
    },
  },
  mainContainer: {
    overflow: 'auto',
    flex: 1,
    width: '100%',
    height: '100%',
    paddingTop: '20vh',
    paddingBottom: 60,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 24,

    '& div[class*=tileHeader]': {
      marginBottom: 8,
      '& .header-title': {
        fontSize: 24,
        lineHeight: '32px',
        fontWeight: 600,
        color: '#242424',
      },
    },
  },
  'mainContainer-s': {
    paddingTop: 24,
  },
  cardContainer: {
    width: 664,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
  },
  'cardContainer-l': {
    width: 618,
  },
  'cardContainer-m': {
    width: 424,
  },
  'cardContainer-s': {
    width: 312,
  },
  cardContentContainer: {
    minHeight: 'auto',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: palette.white,
    borderRadius: 4,
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.12), 0px 2px 4px 0px rgba(0, 0, 0, 0.14)',
    padding: 36,

    '& .container-header': {
      width: '100%',
    },

    '& #notice-string-for-notice-country span': {
      fontSize: 14,
      fontWeight: 400,
      color: '#616161',
    },
  },
  'cardContentContainer-s': {
    padding: 16,
  },
  businessInfoContainer: {
    width: '100%',
    maxWidth: 527,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,

    // Align political ads checkbox indicator vertically with label
    '& .political-ads-declaration-container .political-ads-declaration': {
      paddingLeft: 0,
      paddingRight: 0,
      marginLeft: 0,
    },
    '& .political-ads-declaration-container .fui-Checkbox__indicator': {
      marginLeft: '0 !important',
      width: 20,
      height: 20,
    },
    '& .political-ads-declaration-container .fui-Checkbox__indicator svg': {
      width: 20,
      height: 20,
    },
    '& .political-ads-declaration-container .fui-Checkbox__label': {
      paddingLeft: 0,
    },
    // Remove extra padding from terms-and-conditions for consistent alignment
    '& .terms-and-conditions-container': {
      paddingLeft: 0,
    },
  },
  footerContainer: {
    marginTop: 32,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  'footerContainer-s': {
    '& .ms-Stack': {
      width: '100%',
      justifyContent: 'space-between',
    },
  },
  tailContainer: {
    borderTop: '1px solid #E0E0E0',
    width: '100%',
    flexShrink: 0,
    paddingBottom: 24,
  },
  // Early shell: rendered in the normal React tree (not portaled), but must stay
  // pinned to the viewport bottom regardless of scroll, matching the static shell's design.
  // The border/background stay full-width to match the goal design — pointer-events:none
  // doesn't hide anything, it only opts this element out of click hit-testing, so it can span
  // the full width (including over e.g. a live-chat side panel) without blocking clicks to it.
  // Only tailContainerInner (sized to its own content, not full-width) is actually clickable.
  // z-index 11 stacks above #static-early-shell (z-index 10, set by interactive.ts on handoff).
  tailContainerFixed: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 11,
    pointerEvents: 'none',
    display: 'flex',
    justifyContent: 'center',
    borderTop: '1px solid #E0E0E0',
    paddingBottom: 24,
  },
  tailContainerInner: {
    pointerEvents: 'auto',
  },
  // Early shell: the card-layout div in this branch only wraps the fixed tail-container
  // (Part 1/Part 2 live in the static shell / portals instead), so it has no other content to
  // give it height. Applied only here — never on the shared cardLayout base used by the normal
  // (non-early-shell) flow.
  cardLayoutEarlyShell: {
    minHeight: '100vh',
  },
  // Early shell "Saving..." blocker: Part 1 (static shell), Part 2 and the footer (two separate
  // React portals) are three disjoint DOM subtrees — no single wrapper contains all of them, so
  // UiBlocker's own position:relative/100% container can't be used to cover them as a group.
  // Fixed positioning sidesteps that: it covers the whole viewport independent of which subtree
  // is underneath. zIndex must clear both #static-early-shell (10) and tailContainerFixed (11).
  // Rendered only while isSaving is true (see the isolated-step JSX), so it never sits in the DOM
  // as a permanent, invisible click-blocking box the rest of the time.
  earlyShellSavingOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 12,
  },
});
